/**
 * Values that should be removed from an array. `false` is included to support
 * things like conditional inclusion in arrays:
 *
 * ```ts
 * const items = compact<T>([
 *   condition && value,
 *   anotherValue,
 * ]);
 * ```
 */
export type Empty = false | null | undefined;

export type Present<T> = Exclude<T, Empty>;

/** Narrow to values that should remain in an array. */
export function isPresent<T>(value: T): value is Present<T> {
  return value !== null && value !== undefined && value !== false;
}

/** Remove `false | null | undefined` values from an array. */
export function compact<T>(array: readonly (T | Empty)[]): Present<T>[] {
  return array.filter((value) => isPresent(value));
}
